import { render, staticRenderFns } from "./item-rule.vue?vue&type=template&id=4354ed8e&scoped=true&"
import script from "./item-rule.vue?vue&type=script&lang=js&"
export * from "./item-rule.vue?vue&type=script&lang=js&"
import style0 from "./item-rule.vue?vue&type=style&index=0&id=4354ed8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4354ed8e",
  null
  
)

export default component.exports